import { createContext, useContext, useState, type ReactNode } from 'react';

interface DomainContextType {
    activeDomainId: string | null;
    setActiveDomainId: (id: string | null) => void;
}

const DomainContext = createContext<DomainContextType | undefined>(undefined);

export function DomainProvider({ children }: { children: ReactNode }) {
    const [activeDomainId, setActiveDomainIdState] = useState<string | null>(() => {
        return localStorage.getItem('activeDomainId') || null;
    });

    const setActiveDomainId = (id: string | null) => {
        setActiveDomainIdState(id);
        if (id) {
            localStorage.setItem('activeDomainId', id);
        } else {
            localStorage.removeItem('activeDomainId');
        }
    };

    return (
        <DomainContext.Provider value={{ activeDomainId, setActiveDomainId }}>
            {children}
        </DomainContext.Provider>
    );
}

export function useDomainContext() {
    const context = useContext(DomainContext);
    if (context === undefined) {
        throw new Error('useDomainContext must be used within a DomainProvider');
    }
    return context;
}
